module.exports = __webpack_public_path__ + "public/images/wave.6ca2b3342dec37301b43576b61122728.svg";